export enum SignupPageStep {
  personalDetails,
  accountDetails,
  emailVerification,
}
